<template>
  <v-container fluid class="pa-4">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span class="title">{{ $t('title.komisije') }}</span>
        <div class="d-flex">
          <v-tooltip location="bottom" content-class="custom-tooltip">
            <template #activator="{ props }">
              <v-btn v-bind="props" size="small" variant="outlined" color="primary" class="action-btn" icon="mdi-plus"
                type="button" @click="addKomisija" />
            </template>

            {{ $t('general.addKomisija') }}
          </v-tooltip>
        </div>
      </v-card-title>

      <v-card-text>
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" class="mb-2" autocomplete="off"
          density="compact" />

        <v-data-table :headers="headers" :items="filteredKomisije" :loading="loading"
          :loading-text="$t('general.loading')" class="min-width-table custom-header" :items-per-page="15">

          <!-- Bold naslovi i sort ikonice -->
          <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
            <tr>
              <th v-for="column in columns" :key="column.value" @click="() => column.sortable && toggleSort(column)"
                :style="{
                  cursor: column.sortable ? 'pointer' : 'default',
                  width: column.width,
                  maxWidth: column.width,
                  textAlign:
                    column.value === 'actions'
                      ? 'right'
                      : column.value === 'Status'
                        ? 'center'
                        : 'left'
                }" class="sortable-header">
                <div class="d-flex align-center w-100" :class="column.value === 'actions'
                  ? 'justify-end'
                  : column.value === 'Status'
                    ? 'justify-center'
                    : 'justify-space-between'
                  ">
                  <strong>{{ column.text }}</strong>

                  <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2" :class="{ active: isSorted(column) }">
                    {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                  </v-icon>
                </div>
              </th>
            </tr>
          </template>

          <template v-slot:[`item.Members`]="{ item }">
            <div v-if="item?.Members">
              <div v-for="(member, index) in item.Members.split('\n')" :key="index">
                {{ member }}, {{ index === 0 ? this.typeMembers[0] : this.typeMembers[1] }}
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:[`item.Status`]="{ item }">
            <div class="d-flex justify-center align-center">
              <v-menu location="bottom" offset="4">
                <template #activator="{ props }">
                  <v-btn v-bind="props" variant="text" class="status-btn" :disabled="komisije.length < 2">
                    <img v-if="item.Status === true" :src="statusImages.aktivan" height="22" />
                    <img v-if="item.Status === false" :src="statusImages.neaktivan" height="22" />
                  </v-btn>
                </template>

                <v-list density="compact">
                  <v-list-item v-for="s in statusOptions" :key="s.id" :disabled="(s.id === 1) === item.Status"
                    @click="(s.id === 1) !== item.Status && openConfirmStatusDialog(item, s.id === 1)">
                    <v-list-item-title class="d-flex align-center justify-space-between">
                      {{ s.name }}
                      <v-icon v-if="(s.id === 1) === item.Status" size="14">mdi-check</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>


          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex justify-end action-buttons">
              <v-tooltip location="bottom" content-class="custom-tooltip">
                <template #activator="{ props }">
                  <v-btn v-bind="props" variant="outlined" color="primary" class="mr-2 action-btn" type="button"
                    @click="editKomisija(item)">
                    <v-icon size="16">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                {{ $t('general.uredi') }}
              </v-tooltip>

              <v-tooltip location="bottom" content-class="custom-tooltip">
                <template #activator="{ props }">
                  <v-btn v-bind="props" size="small" variant="outlined" color="red" class="action-btn" type="button"
                    @click="openDeleteDialog(item)">
                    <v-icon size="16">mdi-delete</v-icon>
                  </v-btn>
                </template>
                {{ $t('general.delete') }}
              </v-tooltip>
            </div>
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dijalog za dodavanje/uređivanje zaposlenika -->
    <BaseModal v-model="dialog"
      :title="editMode ? this.$t('modalni.komisije.uredi') : this.$t('modalni.komisije.dodaj')">
      <v-form ref="komisijaForm" v-model="isFormValid">
        <v-row dense>

          <v-col cols="12" md="12">
            <v-text-field v-model="form.Name" :label="$t('modalni.komisije.naziv')" :rules="[rules.required]"
              class="my-text" required />
          </v-col>

        </v-row>

        <v-autocomplete v-model="form.Zaposleni" v-model:search="form.Search" :items="users"
          :label="$t('modalni.komisije.NOVIclan')" item-title="Name" item-value="UserId"
          @update:modelValue="add_member()" :disabled="IsEmptyList" class="my-text" autocomplete="off" />

        <table class="w-100 mt-2" style="font-size: 14px;">
          <thead>
            <tr>
              <th class="text-left pb-2">{{ $t('modalni.komisije.clanovi') }}:</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in form.Members" :key="item.Id">
              <td style="padding: 4px 0;">
                <img src="/yes.png" style="padding-right: 10px; height: 8px;">
                {{ item.Name }}, {{ item.Type }}
              </td>
              <td style="text-align: center; padding-left: 20px;">
                <img src="/x.png" @click="remove_member(item.Id)" style="cursor: pointer; height: 8px;">
              </td>
            </tr>
          </tbody>
        </table>

      </v-form>

      <template #footer>
        <div class="d-flex justify-end ga-2">
          <v-btn variant="outlined" @click="closeDialog">
            <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
          </v-btn>

          <v-btn color="primary" variant="flat" @click="saveKomisija">
            <span style="font-size:14px; font-weight: 600;">{{ $t('general.save') }}</span>
          </v-btn>
        </div>
      </template>

    </BaseModal>

    <!-- Dijalog za potvrdu brisanja komisije -->
    <BaseModal v-model="deleteDialog" :title="this.$t('modalni.komisije.brisi')">
      <p>{{ $t('User_message.m121') }} <strong>{{ deleteKomisijaName }}</strong>?</p>

      <template #footer>
        <div class="d-flex justify-end ga-2">
          <v-btn variant="outlined" @click="deleteDialog = false">
            <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
          </v-btn>

          <v-btn color="danger" variant="flat" @click="confirmDelete">
            <span style="font-size:14px; font-weight: 600; color: #FFF">{{ $t('general.deleteButton') }}</span>
          </v-btn>
        </div>
      </template>
    </BaseModal>

    <!-- PROMJENA STATUSA KOMISIJE -->
    <BaseModal v-model="confirmStatusDialog" :title="$t('modalni.komisije.promjenaStatusa')">
      <p style="font-size: 14px;">
        {{ $t('modalni.popis.promjenaStatusaPoruka1') }}
        <strong>{{ pendingStatusChange?.item?.Name }}</strong>
        {{ $t('modalni.asset.promjenaStatusaPoruka2') }}
        <strong>{{ pendingStatusChange?.value ? $t('general.aktivan') : $t('general.neaktivan') }}</strong>?
      </p>

      <template #footer>
        <div class="d-flex justify-end ga-2">
          <v-btn variant="outlined" @click="cancelStatusChange">
            <span style="font-size:14px; font-weight: 600;">{{ $t('general.cancel') }}</span>
          </v-btn>
          <v-btn color="primary" variant="flat" @click="confirmStatusChange">
            <span style="font-size:14px; font-weight: 600;">{{ $t('general.potvrdi') }}</span>
          </v-btn>
        </div>
      </template>
    </BaseModal>

  </v-container>
</template>

<script>
import { printTable } from "@/services/printService";
import { format } from "date-fns";
import BaseModal from "@/components/dialogs/BaseModal.vue";

export default {
  name: "UsersPage",
  data() {
    return {
      deleteDialog: false,
      deleteKomisijaId: null,
      deleteKomisijaName: "",
      deleteStatus: null,
      search: "",
      users: [],
      IsEmptyList: false,
      loading: false,
      dialog: false,
      editMode: false,
      Id: null,
      komisije: [],
      tempMembers: [],
      confirmStatusDialog: false,
      pendingStatusChange: {
        item: null,
        value: null
      },
      isFormValid: false,
      rules: {
        required: (v) => !!v || this.$t('systemMessage.m1'),
      },

      form: {
        Name: "",
        StatusId: null,
        Zaposleni: null,
        Members: [],
        Search: ''
      },

      headers: [
        { text: this.$t('table.komisije.naziv'), value: "Name", sortable: true, width: 'calc(50% - 100px)' },
        { text: this.$t('table.komisije.datum'), value: "Date", sortable: true, width: '16%' },
        { text: this.$t('table.komisije.clanovi'), value: "Members", sortable: true, width: '23.5%' },
        { text: this.$t('table.komisije.status'), value: "Status", sortable: false, width: '10.5%' },
        { text: this.$t('general.optionsUPPER'), value: "actions", sortable: false, width: '100px' },
      ],

      statusOptions: [
        { id: 1, name: this.$t('general.aktivan') },
        { id: 2, name: this.$t('general.neaktivan') }
      ],
      typeMembers: [this.$t('modalni.komisije.predsjednik'), this.$t('modalni.komisije.clan')]
    };
  },
  components: {
    BaseModal,
  },
  computed: {
    currentLang() {
      const lang = localStorage.getItem('lang')
      if (lang === 'sr' || lang === 'cir-ekavica') return 'Cir'
      if (lang === 'en') return 'Eng'
      return 'Lat'
    },
    statusImages() {
      const lang = this.currentLang
      return {
        aktivan: `/img/aktivan${lang}.png`,
        neaktivan: `/img/neaktivan${lang}.png`,
        rashodovan: `/img/rashodovan${lang}.png`,
      }
    },
    filteredKomisije() {
      if (!this.search) return this.komisije;

      const searchTerm = this.search.toLowerCase();

      return this.komisije.filter(k =>
        k.Name.toLowerCase().includes(searchTerm) ||
        (k.Members && k.Members.toLowerCase().includes(searchTerm))
      );
    }
  },

  async mounted() {
    await this.fetchUsers();
    await this.fetchKomisije();
  },

  methods: {
    printUsers() {
      const data = this.filteredKomisije || []

      if (!data.length) {
        this.$store.dispatch("NOTIF_WARNING", {
          poruka: this.$t('print.na'),
          position: "center",
          icon: "error",
          timer: 4500,
          width: "550"
        })
        return
      }

      printTable({
        title: this.$t('print.listaZaposlenika'),
        columns: [
          { label: this.$t('table.zaposlenici.ime'), width: '20%' },
          { label: this.$t('table.zaposlenici.email'), width: '20%' },
          { label: this.$t('table.zaposlenici.pozicija'), width: '25%' },
          { label: this.$t('table.zaposlenici.orgJedinica'), width: '35%' },
        ],
        data: this.filteredUsers.map(u => ({
          [this.$t('table.zaposlenici.ime')]: u.Name,
          [this.$t('table.zaposlenici.email')]: u.Email,
          [this.$t('table.zaposlenici.pozicija')]: u.WorkPosition,
          [this.$t('table.zaposlenici.orgJedinica')]: u.Department,
        })),
        footer: `${this.$t('print.m1')} ${format(new Date(), "dd.MM.yyyy.")}`
      });
    },
    openDeleteDialog(item) {
      console.log(item)
      this.deleteKomisijaId = item.KomisijaId;
      this.deleteKomisijaName = item.Name;
      this.deleteStatus = item.Status;
      this.deleteDialog = true;
    },

    cancelDelete() {
      this.deleteDialog = false;
      this.deleteUserId = null;
      this.deleteUserName = "";
    },

    async confirmDelete() {
      if (!this.deleteKomisijaId) return;

      try {
        var data = {
          Id: this.deleteKomisijaId,
          CompanyId: Number(localStorage.getItem('CompanyId')),
          Activation: this.deleteStatus
        }

        const r = await this.$axios.put(
          'Komisije/Delete/', data
        );

        if (r.status === 200 || r.status === 204) {
          this.$store.dispatch("NOTIF_SUCCESS", {
            poruka: this.$t('User_message.m119'),
            position: "top-end",
            timer: 2500,
            action: "noreload"
          });

          await this.fetchKomisije();
        }

      } catch (err) {
        this.$store.dispatch("NOTIF_WARNING", {
          poruka: this.$t('User_message.m120'),
          position: "center",
          icon: "error",
          timer: 4500,
          width: "550"
        });
      } finally {
        this.deleteDialog = false;
        this.deleteKomisijaId = null;
        this.deleteKomisijaName = "";
      }
    },

    async fetchKomisije() {
      this.loading = true;
      try {
        var data = {
          Id: Number(localStorage.getItem('CompanyId')),        
          LanguageId: Number(localStorage.getItem('LanguageId')) 
        }

        const r = await this.$axios.post('Komisije/Show/', data)

        this.komisije = r.data

      } catch (err) {
        console.error(this.$t('general.noData'), err)
        this.komisije = [];
      } finally {
        this.loading = false;
      }
    },

    addKomisija() {
      this.editMode = false;
      this.selectedId = null;
      this.resetForm();
      this.form.StatusId = 1;
      this.dialog = true;

      this.$nextTick(() => {
        this.$refs.komisijaForm?.resetValidation()
      })
    },

    async add_member() {
      if (!this.form.Members) {
        this.form.Members = []
      }

      const index = this.users.findIndex(u => u.UserId === this.form.Zaposleni)
      if (index === -1) return

      const user = this.users[index]

      this.form.Members.push({
        Id: user.UserId,
        Name: user.Name,
        Type: this.form.Members.length < 1 ? this.typeMembers[0] : this.typeMembers[1]
      })

      this.users.splice(index, 1);

      await this.$nextTick()
      this.form.Zaposleni = null;
      this.form.Search = '';

      this.users.length == 0 ? this.IsEmptyList = true : this.IsEmptyList = false;
    },
    async remove_member(value) {
      for (var i = 0; i < this.form.Members.length; i++) {
        if (this.form.Members[i].Id == value) {
          this.users.push({
            UserId: this.form.Members[i].Id,
            Name: this.form.Members[i].Name
          })

          this.form.Members.splice(i, 1);
        }
      }

      if (this.form.Members && this.form.Members.length) {
        const postojiPredsjednik = this.form.Members.some(m => m.Type === this.$t('modalni.komisije.predsjednik'))

        if (!postojiPredsjednik) {
          this.form.Members[0].Type = this.$t('modalni.komisije.predsjednik')
        }
      }

      this.users.sort((a, b) => a.id - b.id);
    },

    async fetchUsers() {
      this.loading = true;
      try {
        var data = {
          Id: Number(localStorage.getItem('CompanyId')),        
          LanguageId: Number(localStorage.getItem('LanguageId')) 
        }

        const r = await this.$axios.post('User/Show/', data)

        this.users = r.data

      } catch (err) {
        console.error(this.$t('general.noData'), err)
        this.users = []
      } finally {
        this.loading = false;
      }
    },

    async editKomisija(value) {

      var data = {
        Id: value.KomisijaId,
        LanguageId: Number(localStorage.getItem('LanguageId'))
      }

      const response = await this.$axios.post('Komisije/ShowMembers/', data)

      const members = response.data.members || []

      this.form.Members = members.map((m, index) => ({
        Id: m.id,
        Name: m.name,
        Type: index === 0
          ? this.typeMembers[0]
          : this.typeMembers[1]
      }))


      members.forEach(m => {
        const index = this.users.findIndex(u => u.id === m.id)
        if (index !== -1) {
          this.users.splice(index, 1) // briše 1 element
        }
      })

      this.editMode = true;
      this.selectedId = value.KomisijaId;
      this.form.Name = value.Name;

      value.Status == true ? this.form.StatusId = 1 : this.form.StatusId = 2;

      //this.form = { ...value };
      this.dialog = true;

      this.$nextTick(() => {
        this.$refs.komisijaForm?.resetValidation()
      })
    },

    async saveKomisija() {
      const { valid } = await this.$refs.komisijaForm.validate() // valiadcija forme
      if (!valid) return

      if (!this.form.Name || this.form.Members.length == 0) {
        this.$store.dispatch("NOTIF_WARNING", {
          poruka: this.$t('User_message.m114'),
          position: "center",
          icon: "error",
          timer: 4500,
          width: "550"
        });
        return;
      }

      try {
        if (this.editMode) {

          const data = {
            Id: this.selectedId,
            Name: this.form.Name,
            UserId: this.form.Members.map(m => m.Id)
          };

          const r = await this.$axios.put('Komisije/Edit/', data);

          if (r.data === "UPDATED") {
            this.$store.dispatch("NOTIF_SUCCESS", {
              poruka: this.$t('User_message.m117'),
              position: "top-end",
              timer: 2500,
              action: "noreload"
            });
          } else {
            this.$store.dispatch("NOTIF_WARNING", {
              poruka: this.$t('User_message.m118'),
              position: "center",
              icon: "error",
              timer: 4500,
              width: "550"
            });
          }

        } else {

          const data = {
            Name: this.form.Name,
            UserId: this.form.Members.map(m => m.Id),
            CompanyId: Number(localStorage.getItem('CompanyId'))
          };

          const r = await this.$axios.post('Komisije/Add/', data);

          if (r.data === "INSERTED") {
            this.$store.dispatch("NOTIF_SUCCESS", {
              poruka: this.$t('User_message.m115'),
              position: "top-end",
              timer: 2500,
              action: "noreload"
            });
          } else {
            this.$store.dispatch("NOTIF_WARNING", {
              poruka: this.$t('User_message.m116'),
              position: "center",
              icon: "error",
              timer: 4500,
              width: "550"
            });
          }
        }

        this.dialog = false;
        this.fetchKomisije();

      } catch (err) {
        console.error(this.$t('User_message.m125'), err);
      }
    },
    openConfirmStatusDialog(item, value) {
      this.pendingStatusChange = { item, value }
      this.confirmStatusDialog = true
    },

    async confirmStatusChange() {
      const { item, value } = this.pendingStatusChange

      const data = {
        Id: item.KomisijaId,
        Activation: value,
        CompanyId: Number(localStorage.getItem('CompanyId')),
      }

      try {
        await this.$axios.put('Komisije/EditStatus/', data)

        this.$store.dispatch('NOTIF_SUCCESS', {
          poruka: this.$t('User_message.m150'),
          position: 'top-end',
          timer: 2500,
          action: 'noreload'
        })

        await this.fetchKomisije()
      } catch (err) {
        this.$store.dispatch('NOTIF_WARNING', {
          poruka: this.$t('User_message.m52'),
          position: 'center',
          icon: 'error',
          timer: 4500,
          width: '550'
        })
      } finally {
        this.confirmStatusDialog = false
        this.pendingStatusChange = { item: null, value: null }
      }
    },

    cancelStatusChange() {
      this.confirmStatusDialog = false
      this.pendingStatusChange = { item: null, value: null }
    },

    closeDialog() {
      this.dialog = false;
      this.resetForm();

      this.$nextTick(() => {
        this.$refs.komisijaForm?.resetValidation()
      })
    },

    resetForm() {
      this.form = {
        Name: "",
        StatusId: null,
        Zaposleni: null,
        Members: [],
        Search: ''
      };
      this.selectedId = null;
    }
  }
};
</script>
